import type { RecoveryActionSchema } from "./schema/RecoveryActionSchema";

const recoveryActionMap: Map<string, RecoveryActionSchema> = new Map();
export default recoveryActionMap;
